import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientBoardNameAvatar from "@Shared/@HandlebarsTemplates/general/_client-board-name-avatar.hbs";
import { denormalize } from "normalizr";
import { mapState, mapGetters, mapMutations } from "vuex";
import TransferClientProfileModal from "../../modals/transfer-client-profile-modal";
import ClientProfilesFilterDropdown from "./client-profiles-filter-dropdown";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { BoardColumnSortMixin } from "@Shared/utils/board-mixins";
import { getOutput } from "@Shared/utils/helpers/helpers";
import { collaboratorsSchema } from "@Broker/@Modules/clients/board/store/board-schema";
import { escape, reduce } from "lodash";
import { GET_DEFAULT_CUSTOM_FIELD } from "@Broker/@Modules/clients/board/store/board-getters";
import { SET_BOARDS_CLASSIC_FILTERS } from "@Broker/@Modules/main/store/account/account-mutations";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfilesTable",
  components: {
    ClientProfilesFilterDropdown,
    TransferClientProfileModal
  },
  mixins: [BoardColumnSortMixin],
  props: {
    profiles: {
      type: Object,
      required: true
    },
    boards: {
      type: Array,
      required: true,
      default: () => []
    },
    statusNameList: {
      type: Array,
      default: () => []
    },
    states: {
      type: Array,
      default: () => [],
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableFilters: {
        status: [],
        owner: [],
        collaborators: [],
        applicationFlow: []
      },
      availableFilters: ["status", "owner", "collaborators", "applicationFlow"],
      movingProfile: {
        clientProfileId: "",
        clientProfileName: "",
        statusLabelId: ""
      },
      columns: ["name", "status", "owner", "collaborators", "subjectProperty", "closingDate", "dateCreated", "appType", "referrerName", "nextActivityDate", "value", "move"],
      headings: {
        name: this.$t("global.words.name"),
        subjectProperty: this.$t("global.doorr.subjectProperty"),
        closingDate: this.$t("global.doorr.closingDate"),
        dateCreated: this.$t("global.doorr.dateCreated"),
        referrerName: this.$tc("global.doorr.referrer", 1),
        nextActivityDate: this.$t("boards.messages.nextActivityDate"),
        value: this.$t("global.words.value"),
        move: this.$t("global.words.move")
      },
      columnsClasses: {
        move: "hidden-heading"
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", ["selectedBoardId", "clientProfileSearchString", "boardsStatusesTranslationMap"])), mapState("AccountStore", ["boardClassicFilters"])), mapGetters("BoardStore", [GET_DEFAULT_CUSTOM_FIELD])), {}, {
    boardsWithoutCurrent() {
      var _context;
      return _filterInstanceProperty(_context = this.boards).call(_context, ({
        id
      }) => id !== this.selectedBoardId);
    },
    boardStateFilters() {
      return this.selectedBoardId && this.boardClassicFilters[this.selectedBoardId] || [];
    },
    hasActiveFilters() {
      return this.availableFilters.some(key => this.tableFilters[key].length);
    },
    filteredProfiles() {
      if (!this.boardStateFilters.length) return [];
      if (this.clientProfileSearchString.length >= 3) {
        const profiles = this.searchClientProfile(this.tableFilteredProfiles, this.clientProfileSearchString);
        return this.applyBoardStateFilters(profiles);
      }
      return this.applyBoardStateFilters(this.tableFilteredProfiles);
    },
    tableFilteredProfiles() {
      var _context2;
      if (!this.profileValues || !this.hasActiveFilters) return this.profileValues;
      return _filterInstanceProperty(_context2 = this.profileValues).call(_context2, profile => {
        return this.availableFilters.every(filter => {
          const filterValues = this.tableFilters[filter];
          return filterValues.length === 0 || _findInstanceProperty(filterValues).call(filterValues, this.filterBy(filter, profile));
        });
      });
    },
    profileValues() {
      return this.profiles.byId && _Object$values(this.profiles.byId);
    },
    ownerDropdownOptions() {
      var _context3, _context5;
      if (!this.profileValues) return [];
      const onlyOwners = _mapInstanceProperty(_context3 = this.profileValues).call(_context3, ({
        owner
      }) => {
        var _context4;
        return _trimInstanceProperty(_context4 = `${owner.givenName} ${owner.familyName}`).call(_context4);
      });
      return _mapInstanceProperty(_context5 = _Array$from(new _Set(onlyOwners))).call(_context5, value => ({
        key: "owner",
        value,
        name: value
      }));
    },
    collaboratorsDropdownOptions() {
      var _context6, _context8;
      if (!this.profileValues) return [];
      const onlyCollaborators = _flatMapInstanceProperty(_context6 = this.profileValues).call(_context6, ({
        collaborators
      }) => {
        const allCollaborators = this.denormalizeCollaborators(collaborators);
        return _mapInstanceProperty(allCollaborators).call(allCollaborators, collaborator => {
          var _context7;
          return _trimInstanceProperty(_context7 = `${collaborator.givenName || ""} ${collaborator.familyName || ""}`).call(_context7);
        });
      });
      return _mapInstanceProperty(_context8 = _Array$from(new _Set(onlyCollaborators))).call(_context8, value => ({
        key: "collaborators",
        value,
        name: value
      }));
    },
    statusDropdownOptions() {
      if (!this.profileValues) return [];
      return reduce(this.profileValues, (acc, {
        boardId,
        statusLabelId,
        status
      }) => {
        if (boardId === this.selectedBoardId && !_findInstanceProperty(acc).call(acc, ({
          id
        }) => id === statusLabelId)) acc.push({
          key: "status",
          value: status,
          name: status,
          id: statusLabelId
        });
        return acc;
      }, []);
    },
    applicationFlowDropdownOptions() {
      var _context9, _context0, _context1;
      if (!this.profileValues) return [];
      const onlyApplicationFlow = _mapInstanceProperty(_context9 = this.profileValues).call(_context9, ({
        applicationFlow
      }) => applicationFlow);
      return _mapInstanceProperty(_context0 = _filterInstanceProperty(_context1 = _Array$from(new _Set(onlyApplicationFlow))).call(_context1, value => value)).call(_context0, value => ({
        key: "applicationFlow",
        value,
        name: this.$t("application-flow.flows")[value]
      }));
    },
    tableOptions() {
      return {
        filterable: false,
        sortable: ["name", "subjectProperty", "closingDate", "dateCreated", "referrerName", "nextActivityDate", "value"],
        customSorting: {
          name: ascending => {
            return this.customNameSorting(ascending);
          },
          closingDate: ascending => {
            return this.customDateSorting(ascending, "closingDate");
          },
          nextActivityDate: ascending => {
            return this.customDateSorting(ascending, "nextActionDate");
          },
          value: ascending => {
            return this.customValueSorting(ascending, "value");
          }
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        columns: this.columns,
        headings: this.headings,
        skin: "table table-hover",
        perPage: 999999,
        texts: {
          noResults: this.$t("boards.messages.emptyClients")
        }
      };
    }
  }),
  watch: {
    loading(currentValue, oldValue) {
      if (!currentValue && oldValue) this.updateStatusFilter();
    },
    boardStateFilters() {
      this.updateStatusFilter();
    },
    states() {
      this.updateStatusFilter();
    }
  },
  mounted() {
    this.updateStatusFilter();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations("AccountStore", [SET_BOARDS_CLASSIC_FILTERS])), {}, {
    initTableTooltips() {
      var _context10;
      _findInstanceProperty(_context10 = $(this.$refs.profilesTableWrapper)).call(_context10, "[data-toggle='tooltip'").tooltip();
    },
    filterBy(filter, profile) {
      return filterValue => {
        if (filter === "owner") {
          var _context11;
          const {
            owner
          } = profile;
          const ownerName = _trimInstanceProperty(_context11 = `${owner.givenName} ${owner.familyName}`).call(_context11);
          return filterValue.value === ownerName;
        }
        if (filter === "collaborators") {
          const {
            collaborators
          } = profile;
          const allCollaborators = this.denormalizeCollaborators(collaborators);
          if (!allCollaborators || !allCollaborators.length) return false;
          const collaboratorsName = _mapInstanceProperty(allCollaborators).call(allCollaborators, collaborator => {
            var _context12;
            return _trimInstanceProperty(_context12 = `${collaborator.givenName} ${collaborator.familyName}`).call(_context12);
          });
          return _includesInstanceProperty(collaboratorsName).call(collaboratorsName, filterValue.value);
        }
        return filterValue.value === profile[filter];
      };
    },
    applyBoardStateFilters(profiles) {
      if (!profiles) return profiles;
      const filteredProfiles = _filterInstanceProperty(profiles).call(profiles, ({
        statusLabelId
      }) => {
        var _context13;
        return _includesInstanceProperty(_context13 = this.boardStateFilters).call(_context13, statusLabelId);
      });
      filteredProfiles.forEach(profile => {
        profile.closingDate = this.GET_DEFAULT_CUSTOM_FIELD(profile.id, "Closing Date") || null;
        profile.referrerName = `${profile.referrer.givenName || ""} ${profile.referrer.familyName || ""}`;
      });
      return filteredProfiles;
    },
    handleTableClick(clientProfile) {
      this.movingProfile = {
        clientProfileId: clientProfile.id,
        clientProfileName: `${clientProfile.givenName} ${clientProfile.familyName}`,
        statusLabelId: clientProfile.statusLabelId
      };
      showBModal("transfer-client-modal", {}, this);
    },
    denormalizeCollaborators(collaborators) {
      const {
        allIds,
        byId
      } = collaborators;
      return denormalize(allIds, [collaboratorsSchema], {
        collaborators: byId
      });
    },
    updateStatusFilter() {
      this.tableFilters.status = reduce(this.states, (acc, {
        id,
        label
      }) => {
        var _context14;
        if (_includesInstanceProperty(_context14 = this.boardStateFilters).call(_context14, id)) acc.push({
          key: "status",
          name: label,
          value: label,
          id
        });
        return acc;
      }, []);
    },
    handleStatusFilterChange(selectedStatuses) {
      this.tableFilters.status = selectedStatuses;
      this.SET_BOARDS_CLASSIC_FILTERS({
        boardId: this.selectedBoardId,
        value: _mapInstanceProperty(selectedStatuses).call(selectedStatuses, ({
          id
        }) => id)
      });
    },
    formatStatus(status) {
      var _context15, _this$$options$filter;
      return escape(_trimInstanceProperty(_context15 = (_this$$options$filter = this.$options.filters.getSchemaTranslation(status, this.boardsStatusesTranslationMap[this.selectedBoardId])) != null ? _this$$options$filter : status).call(_context15));
    },
    formatAppType(applicationFlow) {
      if (!applicationFlow) return "";
      return this.$t(`application.flow.${applicationFlow}`);
    },
    formatCollaboratorsTitle(collaborators) {
      const allCollaborators = this.denormalizeCollaborators(collaborators);
      return getOutput("timeline-assignee-tooltip", "assignees", allCollaborators);
    },
    formatName(row) {
      return ClientBoardNameAvatar(row);
    },
    customDateSorting(ascending, column) {
      return function (a, b) {
        const dateA = new Date(a[column]);
        const dateB = new Date(b[column]);
        if (ascending) return dateA >= dateB ? 1 : -1;
        return dateA <= dateB ? 1 : -1;
      };
    },
    customNameSorting(ascending) {
      return function (a, b) {
        const nameA = `${a.givenName || ""} ${a.familyName || ""}`.toLowerCase();
        const nameB = `${b.givenName || ""} ${b.familyName || ""}`.toLowerCase();
        if (ascending) return nameA >= nameB ? 1 : -1;
        return nameA <= nameB ? 1 : -1;
      };
    },
    customValueSorting(ascending) {
      return function (a, b) {
        const valueA = _parseFloat(a.value) || 0;
        const valueB = _parseFloat(b.value) || 0;
        if (ascending) {
          return valueA - valueB;
        } else {
          return valueB - valueA;
        }
      };
    }
  })
});